<template>
  <div class="wrapper">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="item in list"
        :key="item.id"
        class="grid__item news"
      >
        <div class="news__container">
          <div class="news__content">
            <div class="news__descr">
              <div class="news__img">
                <div class="news__category">
                  {{ item.sub_category.name }}
                </div>
                <ImageContainer
                  class="img"
                  :src="item.image.medium"
                  :thumb="item.image.thumbnail"
                  :alt="item.title"
                />
              </div>
              <div class="news__title">
                <h3 class="limited-text">{{ item.title }}</h3>
                <div class="data-news">
                  <span class="day">{{ handleDate(item.pub_date) }},</span>
                  <span class="time">{{ handleTime(item.pub_date) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";

export default {
  name: "ThirdBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
$data-color: rgba(255, 255, 255, 0.7);
$green: #447562;
.wrapper {
  max-width: 95%;
  margin: 0 auto;
  @media screen and (max-width: 767px) {
    width: 90%;
  }
}
.grid {
  display: grid;
  grid-template-columns: repeat(18, 1fr);
  padding-bottom: 1rem;
  gap: 2rem;
  width: 100%;
  @media screen and (max-width: 992px) {
    gap: 1rem;
  }
  @media screen and (max-width: 767px) {
    display: block;
  }

  &__item {
    .news {
      margin-top: 1rem;
    }
  }
  &__item:nth-child(1) {
    grid-column: 1 / span 9;
    @media screen and (max-width: 992px) {
      grid-column: 1 / span 9;
      grid-row: 1 / span 2;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 18;
      // grid-row: 1;
    }
    .news {
      &__container {
        @media screen and (max-width: 992px) {
        }
        @media screen and (max-width: 767px) {
          height: 88px;
        }
      }
      &__img {
        flex: 0 0 58%;
        // height: 389px;
        position: relative;
        text-align: left;
        .img {
          padding-bottom: 75%;
        }
        @media screen and (max-width: 992px) {
          text-align: left;
          min-height: 100%;
          height: 100%;
          // .img {
          //   padding-bottom: 60%;
          // }
        }
        @media screen and (max-width: 767px) {
          height: 66px;
          flex: 1 0 88px;
        }
      }
      &__content {
        @media screen and (max-width: 992px) {
        }
      }
      &__category {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: $green;
        padding: 2px 5px;
        @media screen and (max-width: 992px) {
          position: relative;
        }
        @media screen and (max-width: 767px) {
        }
      }
      &__descr {
        text-align: right;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        @media screen and (max-width: 992px) {
          display: block;
          position: relative;
          overflow: hidden;
        }
        @media screen and (max-width: 767px) {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          overflow: visible;
        }
      }
      &__title {
        @media screen and (max-width: 992px) {
          background: $green;
          width: 100%;
          .limited-text {
            position: absolute;
            bottom: 31px;
            right: 0;
            z-index: 2;
            width: 62%;
            text-align: left;
            background-color: $green;
            padding: 0.5rem 1rem 0 1rem;
            z-index: 2;
            @media screen and (max-width: 767px) {
              position: relative;
              padding: 0;
              width: 100%;
              bottom: 0;
              margin-top: 2.1rem;
            }
          }
        }
        @media screen and (max-width: 767px) {
          position: relative;
          display: block;
        }

        .data-news {
          @media screen and (max-width: 992px) {
            position: absolute;
            bottom: 0;
            left: 0;
            padding: 0.5rem;
            width: 100%;
            text-align: left;
            background: $green;
            z-index: 0;
            @media screen and (max-width: 767px) {
              position: relative;
              padding: 0;
            }
          }
        }
      }
    }
  }
  &__item:nth-child(2) {
    grid-column: 10 / span 9;
    @media screen and (max-width: 992px) {
      grid-row: 1 / span 1;
      align-self: end;
      transform: translateY(10%);
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 18;
      transform: translateY(0);
    }
    .news {
      &__container {
        @media screen and (max-width: 992px) {
        }
        @media screen and (max-width: 767px) {
          height: 100px;
        }
      }
      &__img {
        flex: 0 0 58%;
        // height: 389px;
        position: relative;
        text-align: left;
        .img {
          padding-bottom: 75%;
        }
        @media screen and (max-width: 992px) {
          height: 67px;
          max-width: 90px;
          .img {
            padding-bottom: 0%;
          }
        }
        @media screen and (max-width: 767px) {
          max-width: 105px;

          height: 79px;
        }
      }
      &__content {
        @media screen and (max-width: 992px) {
        }
      }
      &__category {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: $green;
        padding: 2px 5px;
        @media screen and (max-width: 992px) {
          position: relative;
        }
      }
      &__descr {
        text-align: right;
        display: flex;
        flex-direction: row;
        align-items: center;
        text-align: left;
        @media screen and (max-width: 992px) {
          align-items: flex-start;
        }
        @media screen and (max-width: 767px) {
          align-items: flex-start;
        }
      }
      &__title {
        @media screen and (max-width: 992px) {
          margin-top: 1.2em;
        }
        @media screen and (max-width: 767px) {
          margin-top: 2rem;
        }

      }
    }
  }
  &__item:nth-child(3) {
    grid-column: 1 / span 9;
    @media screen and (max-width: 992px) {
      grid-column: 10 / span 9;
      grid-row: 2 / span 1;
      align-self: flex-start;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 18;
    }
    .news {
      &__container {
        @media screen and (max-width: 992px) {
          grid-row: 1 / span 1;
        }
        @media screen and (max-width: 767px) {
          height: 110px;
        }
      }
      &__img {
        flex: 0 0 58%;
        // height: 389px;
        position: relative;
        text-align: left;
        .img {
          padding-bottom: 75%;
        }
        @media screen and (max-width: 992px) {
          height: 67px;
          max-width: 90px;
          .img {
            padding-bottom: 0%;
          }
        }
        @media screen and (max-width: 767px) {
          height: 90px;
          max-width: 119px;
        }
      }
      &__content {
        @media screen and (max-width: 992px) {
        }
      }
      &__category {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: $green;
        padding: 2px 5px;
        @media screen and (max-width: 992px) {
          position: relative;
        }
      }
      &__descr {
        text-align: right;
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        @media screen and (max-width: 992px) {
          flex-direction: row;
          text-align: left;
        }
        @media screen and (max-width: 767px) {
        }
      }
      &__title {
        @media screen and (max-width: 992px) {
          // margin-top: 2em;
          transform: translateY(2em);
        }
        @media screen and (max-width: 767px) {
          transform: translateY(0);
          margin-top: 3em;
        }


      }
    }
  }
  &__item:nth-child(4) {
    grid-column: 10 / span 9;
    @media screen and (max-width: 992px) {
      grid-column: 1 / span 9;
      grid-row: 3 / span 1;
      height: min-content;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 18;
    }
    .news {
      &__container {
        @media screen and (max-width: 992px) {
        }
        @media screen and (max-width: 767px) {
          height: 140px;
        }
      }
      &__img {
        flex: 0 0 58%;
        // height: 389px;
        position: relative;
        text-align: left;
        .img {
          padding-bottom: 75%;
        }
        @media screen and (max-width: 992px) {
          height: 67px;
          max-width: 90px;
          .img {
            padding-bottom: 0%;
          }
        }
        @media screen and (max-width: 767px) {
          min-width: 144px;
          // height: 109px;
          .img {
            padding-bottom: 75%;
          }
        }
      }
      &__content {
        @media screen and (max-width: 767px) {
          height: 100%;
        }
      }
      &__category {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-color: $green;
        padding: 2px 5px;
        @media screen and (max-width: 992px) {
          position: relative;
          background: transparent;
        }
      }
      &__descr {
        text-align: right;
        display: flex;
        flex-direction: row;
        align-items: center;
        text-align: left;
        @media screen and (max-width: 992px) {
          align-items: flex-start;
        }

        @media screen and (max-width: 767px) {
          height: 100%;
        }
      }
      &__title {
        @media screen and (max-width: 992px) {
          margin-top: 1.5rem;
        }
        @media screen and (max-width: 767px) {
          margin-top: 3rem;
        }
      }
    }
  }
  &__item:nth-child(5) {
    grid-column: 2 / span 5;
    @media screen and (max-width: 992px) {
      grid-column: 10 / span 9;
      grid-row: 3 / span 1;
      height: min-content;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 18;
    }
    .news {
      &__container {
        // height: 125px;
        height: 100%;
        @media screen and (max-width: 992px) {
        }
        @media screen and (max-width: 767px) {
          height: 110px;
        }
      }
      &__img {
        flex: 0 0 40%;
        height: 100%;
        .img {
          padding-bottom: 66%;
        }
        @media screen and (max-width: 992px) {
          height: 67px;
          max-width: 90px;
        }
        @media screen and (max-width: 767px) {
          height: 90px;
          max-width: 119px;
        }
      }
      &__content {
        // width: 80%;
        height: 100%;

        margin: 0 auto;
        @media screen and (max-width: 992px) {
          width: 100%;
        }
      }
      &__category {
        @media screen and (max-width: 767px) {
        }
      }
      &__descr {
        display: flex;

        @media screen and (max-width: 992px) {
          height: 100%;
        }
      }
      &__title {
        margin-top: 1.1rem;
        margin-left: 0.5rem;
        display: flex;
        flex-direction: column;
        align-self: center;

        line-height: 23px;
        letter-spacing: 0.03em;
        @media screen and (max-width: 992px) {
          margin-left: 0rem;

          font-style: normal;
          font-size: 16px;
          line-height: 22px;
        }
        @media screen and (max-width: 767px) {
          font-size: 12px;
          line-height: 15px;
        }


      }
    }
  }
  &__item:nth-child(6) {
    grid-column: 8 / span 5;
    transform: translateX(-12%);
    @media screen and (max-width: 992px) {
      transform: translateX(0%);

      grid-column: 1 / span 9;
      grid-row: 4 / span 1;
      height: min-content;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 18;
    }
    .news {
      &__container {
        height: 100%;

        @media screen and (max-width: 992px) {
        }
        @media screen and (max-width: 767px) {
          height: 100px;
        }
      }
      &__img {
        flex: 1 0 40%;
        height: 100%;
        .img {
          padding-bottom: 66%;
        }
        @media screen and (max-width: 992px) {
          height: 67px;
          max-width: 90px;
        }
        @media screen and (max-width: 767px) {
          height: 79px;
          max-width: 105px;
        }
      }
      &__content {
        height: 100%;
        margin: 0 auto;
        @media screen and (max-width: 992px) {
          @media screen and (max-width: 992px) {
            width: 100%;
          }
        }
      }
      &__category {
        @media screen and (max-width: 767px) {
        }
      }
      &__descr {
        display: flex;
        @media screen and (max-width: 992px) {
          height: 100%;
        }
      }
      &__title {
        margin-top: 1.1rem;
        margin-left: 0.5rem;
        display: flex;
        flex-direction: column;
        align-self: center;

        line-height: 23px;
        letter-spacing: 0.03em;
        @media screen and (max-width: 992px) {
          margin-left: 0rem;

          font-style: normal;
          font-size: 16px;
          line-height: 22px;
        }
        @media screen and (max-width: 767px) {
          font-weight: 600;
          font-size: 12px;
          line-height: 15px;
        }


      }
    }
  }
  &__item:nth-child(7) {
    grid-column: 13 / span 5;

    &__container {
      @media screen and (max-width: 992px) {
      }
      @media screen and (max-width: 767px) {
      }
    }
    &__img {
      @media screen and (max-width: 992px) {
      }
      @media screen and (max-width: 767px) {
      }
    }
    &__content {
      @media screen and (max-width: 992px) {
      }
    }
    @media screen and (max-width: 992px) {
      grid-column: 10 / span 9;
      grid-row: 4 / span 1;
      height: min-content;
    }
    @media screen and (max-width: 767px) {
      grid-column: 1 / span 18;
    }
    .news {
      &__container {
        height: 100%;

        @media screen and (max-width: 992px) {
        }
        @media screen and (max-width: 767px) {
          height: 88px;
        }
      }
      &__img {
        flex: 1 0 40%;
        height: 100%;
        .img {
          padding-bottom: 66%;
        }
        @media screen and (max-width: 992px) {
          height: 67px;
          max-width: 90px;
        }
        @media screen and (max-width: 767px) {
          height: 66px;
          max-width: 88px;
        }
      }
      &__content {
        // width: 80%;
        height: 100%;
        margin: 0 auto;
        @media screen and (max-width: 992px) {
          width: 100%;
        }
      }
      &__category {
        @media screen and (max-width: 767px) {
        }
      }
      &__descr {
        display: flex;

        @media screen and (max-width: 992px) {
          height: 100%;
        }
      }
      &__title {
        margin-top: 1.1rem;
        margin-left: 0.5rem;
        display: flex;
        flex-direction: column;
        align-self: center;

        line-height: 23px;
        letter-spacing: 0.03em;
        @media screen and (max-width: 992px) {
          margin-left: 0rem;
          font-style: normal;
          font-size: 16px;
          line-height: 22px;
        }
        @media screen and (max-width: 767px) {
          font-size: 12px;
          line-height: 14px;
        }

      }
    }
  }
}
.data-news {
  margin-top: 8px;
  font-size: 0.7em;

  font-family: Open Sans;
  @media screen and (max-width: 992px) {
    font-size: 10px;
  }
  @media screen and (max-width: 767px) {
    color: $data-color;
  }
}
.news {
  &__category {
    font-family: Open Sans;
    font-size: 16px;
    line-height: 22px;
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      color: rgba(255, 255, 255, 0.7);
      text-transform: uppercase;
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
  }
  &__title {
    font-size: 1.2em;
    font-weight: 500;
    line-height: 130%;
    padding: 0 0.5rem;
    @media screen and (max-width: 992px) {
      font-size: 16px;
      line-height: 22px;
    }
    @media screen and (max-width: 767px) {
      font-style: normal;
      font-weight: 500 !important;
      font-size: 12px;
      line-height: 15px;
    }

    .news__content {
      @media screen and (max-width: 767px) {
        // height: 100% !important;
      }
    }

    .data-news {
      font-family: Open Sans;
      font-size: 0.732em;

      line-height: 19px;
      @media screen and (max-width: 992px) {
        font-family: Open Sans;
        font-size: 13px;
        line-height: 18px;
      }
      @media screen and (max-width: 767px) {
        font-family: Open Sans;
        font-size: 10px;
        line-height: 14px;
        margin-top: 0 !important;
      }
    }
  }
}
</style>
